import {useState} from 'react';
import Document from './Document';
import Log from './Log';
import Table from './Table';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {ReactComponent as CopyIcon} from '../../../assets/feedback/copy.svg';
import styles from './styles/answer.module.css';

export default function Answer({ answerList, type }) {
    const [selectedTab, setSelectedTab] = useState(0);
    const [showAlert, setShowAlert] = useState(false);

    const isRenderDocument = (type) => {
        if (type === 'ABNORMAL' || type === 'DOCUMENT' || type === 'EMAIL' || type === 'FAQ' || type === 'REPORT' || type === 'ANALYSIS') return true;
        return false;
    };

    const isRenderThink = (type) => {
        if (type === 'DATABASE' || type === 'ABNORMAL' || type === 'REPORT' || type === 'ANALYSIS') return true;
        return false;
    };

    const isRenderSql = (type) => {
        if (type === 'DATABASE') return true;
        return false;
    };

    const copyText = () => {
        setShowAlert(true);

        setTimeout(() => {
            setShowAlert(false);
        }, 1000);
    };

    const moveScenarioPage = (id) => {
        if (id) {
            window.open(`/admin/scenario/${id}`, '_blank');
        } else {
            window.open(`/admin/scenario`, '_blank');
        }
    };

    return (
        <>
            {answerList.length > 1 &&
                <div className={styles.containerTap}>
                    {answerList.map((answer, index) => (
                        <button className={index === selectedTab ? `${styles.tap} ${styles.tapActive}` : styles.tap}
                                key={index}
                                onClick={() => setSelectedTab(index)}
                        >
                            답변 {index + 1}
                        </button>
                    ))}
                </div>
            }

            <div className={styles.wrapper}>
                <div>
                    {type === 'DATABASE' &&
                        <p className={styles.answer}>
                            {answerList[selectedTab].answer}
                        </p>
                    }
                    {isRenderDocument(type) && <Document content={answerList[selectedTab].answer} references={answerList[selectedTab].references}/>}
                    {answerList[selectedTab].table.length > 0 && <Table table={answerList[selectedTab].table}/>}
                </div>

                {/* <div>
                    <p className={styles.title}>과정 로그</p>
                    <Log logList={answerList[selectedTab].log}/>
                </div> */}

                {isRenderThink(type) &&
                    <div>
                        <p className={styles.title}>사고 과정</p>
                        <div className={styles.box} datatype={!answerList[selectedTab].think && 'none'}>
                            {answerList[selectedTab].think
                                ? <p>{answerList[selectedTab].think}</p>
                                : <p>사고 과정 없음</p>
                            }
                        </div>
                    </div>
                }

                {isRenderSql(type) && 
                    <div>
                        <div className={styles.boxSQL}>
                            <p>SQL</p>
                            <CopyToClipboard
                                text={answerList[selectedTab].sql || '사용된 SQL 없음'}
                                onCopy={copyText}
                            >
                                <button>
                                    <CopyIcon/>
                                    복사
                                </button>
                            </CopyToClipboard>
                        </div>
                        <div
                            className={styles.box}
                            datatype={!answerList[selectedTab].sql && 'none'}
                        >
                            {answerList[selectedTab].sql || '사용된 SQL 없음'}
                        </div>
                        {showAlert && <div className={styles.alertCopy}>복사되었습니다.</div>}
                    </div>
                }

                {/* <div>
                    <p className={styles.title}>시나리오</p>
                    <div className={styles.boxScenario}>
                        {answerList[selectedTab].scenario
                            ? <p
                                className={styles.scenario}
                                onClick={() => moveScenarioPage(answerList[selectedTab].scenarioId)}
                            >
                                {answerList[selectedTab].scenario}
                            </p>
                            : <p className={`${styles.scenario} ${styles.inactiveScenario}`}>연결된 시나리오 없음</p>
                        }
                    </div>
                </div> */}
            </div>
        </>
    );
}
